module.exports = __webpack_public_path__ + "img/Poker_Chip_Purple.de483408.svg";